export default class ValidationTool {
  public static requiredAndPositiveRuleFunction(value: number | string): boolean | string {
    if (!value && value !== 0 && `${value}` !== '0') {
      return 'Required';
    } if (value < 0) {
      return 'Must be positive';
    }
    return true;
  }

  public static tierRateMustBeHigherThanNonQualifyingRateRuleFunction(tierRate: number, nonQualRate: number): boolean | string {
    const tieredRateAsNumber = (tierRate === null || tierRate === undefined) ? NaN : Number(tierRate);
    const nonQualRateAsNumber = (nonQualRate === null || nonQualRate === undefined) ? NaN : Number(nonQualRate);

    if (Number.isNaN(tieredRateAsNumber) || Number.isNaN(nonQualRateAsNumber) || nonQualRateAsNumber > tieredRateAsNumber) {
      return `Tier Rate must be higher than or equal to the Non-Qualifying Rate (Currently set at ${nonQualRate}). Please adjust your configuration before saving.`;
    }

    return true;
  }

  public static nonQualifyingRateMustBeLowerThanAnyTierRateRuleFunction(nonQualRate: any, tierRate: any): boolean | string {
    const tieredRateAsNumber = (tierRate === null || tierRate === undefined) ? NaN : Number(tierRate);
    const nonQualRateAsNumber = (nonQualRate === null || nonQualRate === undefined) ? NaN : Number(nonQualRate);

    if (Number.isNaN(tieredRateAsNumber) || Number.isNaN(nonQualRateAsNumber) || nonQualRateAsNumber > tieredRateAsNumber) {
      return `The non-qualifying rate must be lower than or equal to all tiered rates (Lowest currently set at ${tierRate}). Please adjust your configuration before saving.`;
    }

    return true;
  }

  public static requiredAndBetweenRuleFunction(value: number | string, min: number, max: number, fieldName: string): boolean | string {
    if (!value && value !== 0 && `${value}` !== '0') {
      return `${fieldName} is required`;
    } if (!ValidationTool.isIntegerValue(value)) {
      return `${fieldName} is not a number`;
    } if ((value as number) < min || (value as number) > max) {
      return `${fieldName} must have a value of least ${min} and at most ${max}`;
    }
    return true;
  }

  public static isIntegerValue(value: string | number): boolean {
    return !Number.isNaN(parseInt(`${value}`, 10)) && /^-?\d+$/.test(`${value}`);
  }
}
